export function parseSparqlParams(query: string): string[] {
  let params: string[] = []
  let inSelect = false
  let inParentheses = 0
  let lastAliasParam: string | null = null
  let insideAlias = false

  const tokens = query
    .replace(/\r?\n/g,' ')
    .match(/\(|\)|\?[\w]+|as|\*|\w+|["'][^"']*["']|SELECT|WHERE|{|}/gi)

  if (!tokens) return []

  for (const token of tokens) {
    if (token.toUpperCase() === 'SELECT') {
      inSelect = true
      continue
    }

    if (token.toUpperCase() === 'WHERE' || token === '{') {
      break
    }

    if (inSelect) {
      if (token === '*') {
        if (inParentheses === 0) {
          return []
        }
      }
      if (token === '(') {
        inParentheses++
        if (!insideAlias) {
          insideAlias = true
          lastAliasParam = null
        }
      } else if (token === ')') {
        inParentheses--
        if (inParentheses === 0) {
          insideAlias = false
          if (lastAliasParam) {
            params.push(lastAliasParam)
          }
        }
      } else if (token.startsWith('?')) {
        const param = token.replace('?', '')
        if (insideAlias) {
          lastAliasParam = param
        } else {
          params.push(param)
        }
      }
    }
  }

  return params
}
